module.exports = __webpack_public_path__ + "img/slide1.1997c5e2.jpg";